import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Sorters } from "../../../types";
import { Props } from "./types";
import styles from "./styles.scss";

function DropDownList({
  sortOptions,
  activeSorter,
  setActiveSorter,
  select,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.dropDownList}>
      {Object.values(Sorters).map((sorterName, key) => {
        return (
          typeof sorterName === "number" && (
            <div
              key={key}
              className={classNames(styles.element, {
                [styles.selected]: activeSorter === sorterName,
              })}
              onClick={() => select(setActiveSorter(sorterName))}
            >
              <p>{t(sortOptions[sorterName])}</p>
            </div>
          )
        );
      })}
    </div>
  );
}

export { DropDownList };
